import { Button, Paper, Typography, Stack } from '@mui/material';
import React from 'react';
import { FilterList } from '@mui/icons-material';
import { CompanyTypeAutocomplete } from './fields/CompanyTypeAutocomplete';
import { CountriesAutocomplete } from './fields/CountriesAutocomplete';
import { CertificationsAutocomplete } from './fields/CertificationsAutocomplete';
import { MembershipsAutocomplete } from './fields/MembershipsAutocomplete';
import { CompanySizeAutocomplete } from './fields/CompanySizeAutocomplete';
import { SearchField } from './fields/SearchField';
import { TaxonomyAutocomplete } from './fields/TaxonomyAutocomplete';
import { useAuth } from '../../../../context/Auth';
import { useTranslation } from 'next-i18next';
import { useWatch } from 'react-hook-form-mui';

const nameSpaces = ['directory', 'common'];
export const FilterPanel = () => {
  const { t } = useTranslation(nameSpaces);
  const { textileCompanyType } = useWatch();

  console.log(textileCompanyType);

  const isImporterSelected = textileCompanyType === 'importer';

  const { isAuthenticated } = useAuth();
  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <SearchField
          name="fulltext"
          label={t('common:panel:search')}
          placeholder={t('common:panel:search')}
        />

        <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {t('directory:list:search:filters')}
          <FilterList />
        </Typography>

        <CompanyTypeAutocomplete
          name="textileCompanyType"
          label={t('common:panel:company_type')}
        />

        <TaxonomyAutocomplete
          name="categories"
          label={t('common:panel:categories')}
          disabled={isImporterSelected}
        />

        <CountriesAutocomplete
          name="countryId"
          label={t('common:panel:country')}
          disabled={isImporterSelected}
        />

        <CompanySizeAutocomplete
          name="companySize"
          label={t('common:panel:size')}
          disabled={isImporterSelected}
        />

        <CertificationsAutocomplete
          name="certificationId"
          label={t('common:panel:certifications')}
          disabled={isImporterSelected}
        />

        <MembershipsAutocomplete
          name="membershipId"
          label={t('common:panel:memberships')}
          disabled={isImporterSelected}
        />

        <Button
          type="submit"
          sx={{ width: '100%' }}
          disabled={!isAuthenticated}
        >
          {t('common:panel:apply')}
        </Button>
      </Stack>
    </Paper>
  );
};
